export interface CourtSlide {
  /** Path under public/ (e.g. /images/courts/futsal.jpg) */
  src: string;
  alt: string;
  caption: string;
  sport: string;
}

/** Local files in public/images/courts/ — no external CDN required. */
export const courtSlides: CourtSlide[] = [
  {
    src: '/images/courts/futsal.svg',
    alt: 'Indoor futsal court',
    caption: 'Futsal turf',
    sport: 'Futsal',
  },
  {
    src: '/images/courts/badminton.svg',
    alt: 'Badminton court indoors',
    caption: 'Badminton courts',
    sport: 'Badminton',
  },
  {
    src: '/images/courts/indoor-cricket.svg',
    alt: 'Indoor cricket nets',
    caption: 'Indoor cricket nets',
    sport: 'Indoor Cricket',
  },
  {
    src: '/images/courts/indoor-cricket-nets.svg',
    alt: 'Indoor cricket practice nets',
    caption: 'Cricket practice nets',
    sport: 'Indoor Cricket Nets',
  },
  {
    src: '/images/courts/pickleball.svg',
    alt: 'Pickleball courts',
    caption: 'Pickle ball courts',
    sport: 'Pickle Ball',
  },
  {
    src: '/images/courts/indoor-golf.svg',
    alt: 'Indoor golf simulator bays',
    caption: 'Indoor golf',
    sport: 'Indoor Golf',
  },
  {
    src: '/images/courts/facility.svg',
    alt: 'The Sports Hub multi-sport facility',
    caption: 'Multi-sport facility',
    sport: 'The Sports Hub',
  },
];
